import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

import SearchModeIndex from 'components/search/SearchModeIndex.vue';
import SearchModeTable from 'components/search/SearchModeTable.vue';
import {useSearchStore} from 'stores/search-store';


export default /*#__PURE__*/_defineComponent({
  __name: 'SearchModePane',
  setup(__props) {

const searchStore = useSearchStore();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (!_unref(searchStore).isTableModeSelected)
      ? (_openBlock(), _createBlock(SearchModeIndex, { key: 0 }))
      : _createCommentVNode("", true),
    (_unref(searchStore).isTableModeSelected)
      ? (_openBlock(), _createBlock(SearchModeTable, { key: 1 }))
      : _createCommentVNode("", true)
  ]))
}
}

})